module.exports = __webpack_public_path__ + "img/blockchain-acelerator_logo.4c38d82c.svg";